import { utf8ToBytes } from '@ethereumjs/util';
export const ROOT_DB_KEY = utf8ToBytes('__root__');
//# sourceMappingURL=types.js.map